import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, EyeIcon, CheckCircleIcon } from 'lucide-react';
const outcomes = [{
  icon: ZapIcon,
  title: 'Zero admin',
  description: 'Spend together, log expenses — KittyPot handles the rest automatically.'
}, {
  icon: EyeIcon,
  title: 'Total transparency',
  description: 'Every transaction visible in real time. Everyone knows where the money went.'
}, {
  icon: CheckCircleIcon,
  title: 'No debts at the end',
  description: 'Close the kitty and balances resolve instantly. No awkward messages.'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function ProductDeepDive() {
  return <section className="py-24 lg:py-32 bg-gray-950 relative overflow-hidden" data-id="element-222">
      {/* Subtle radial glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-223">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-kitty-yellow/5 rounded-full blur-3xl" data-id="element-224" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-2xl mx-auto mb-16 lg:mb-20" data-id="element-226">
          <p className="text-sm font-semibold text-kitty-yellow uppercase tracking-widest mb-4" data-id="element-227">
            Why it works
          </p>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-5 tracking-tight leading-tight" data-id="element-228">
            You enjoy the moment. We handle the money.
          </h2>
          <p className="text-lg text-gray-400 max-w-lg mx-auto leading-relaxed" data-id="element-229">
            No spreadsheets. No stress. No chasing.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} className="grid md:grid-cols-3 gap-6 lg:gap-8" data-id="element-230">
          {outcomes.map(item => <motion.div key={item.title} variants={itemVariants} className="rounded-2xl border border-gray-800 bg-gray-900/60 backdrop-blur-sm p-8 lg:p-10 group" data-id="element-231">
              <div className="w-12 h-12 rounded-xl bg-kitty-yellow/10 flex items-center justify-center mb-6 group-hover:bg-kitty-yellow/20 transition-colors duration-300" data-id="element-232">
                <item.icon className="w-6 h-6 text-kitty-yellow" data-id="element-233" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3 leading-snug" data-id="element-234">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-235">
                {item.description}
              </p>
            </motion.div>)}
        </motion.div>

        {/* Confidence line */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-center text-gray-500 text-sm mt-12 lg:mt-16" data-id="element-236">
          Built for groups who'd rather enjoy the moment than do the maths.
        </motion.p>
      </div>
    </section>;
}